<template>
  <div class="text-center text-muted mt-3 mb-3">
    <font-awesome :icon="['fal', 'circle-notch']" spin :size="size" :style="iconStyle"/>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      required: false,
      type: String,
      default: '2x'
    },
    iconStyle: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
